// extracted by mini-css-extract-plugin
export default {"root":"F86F5AJSBFGDvNy03w0d","page":"oCp7F6zpuU08eHKivm36"};